import './NotFound.scss'

const NotFound: React.FC = () => {
    return (
        <div className="not-found-container">
            <section className='not-found'>
                <h2 className='section__title'>404 - Page Not Found</h2>
                <p className='not-found__message'>The page you are looking for does not exist.</p>
                <a href="/" className='btn btn--outline'>Go to Home</a>
            </section>
        </div>
    )
}

export default NotFound
